import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class PaymentTermDueTypeLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            value: this.props.value || '',
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            value: nextProps.value || '',
        })
    }

    render() {
        switch (this.state.value) {
            case 'fixed-days':
                return <FormattedMessage
                    id="payment_term.type.fixed_days_label"
                    defaultMessage="Due in fixed number of days"
                />
            case 'day-of-month':
                return <FormattedMessage
                    id="payment_term.type.day_of_month_label"
                    defaultMessage="Due by certain day of month"
                />
        }
        return <span />
    }


}

export default PaymentTermDueTypeLabel





// WEBPACK FOOTER //
// ./src/payment-term/duetypelabel.component.jsx